import React from 'react';
import { useTranslate } from '@agilepoint/wat-react';

export function useValidatePasswordHook(props?: any) {
    const { password } = props;
    const translate = useTranslate();

    const validatePasswordPattern = React.useCallback((value: string) => {
        if (value && !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_\W])[A-Za-z\d_\W](?!.*\s).{8,15}$/.test(value)) {
            return translate('modules.createNewApp.steps.basicSettings.validationMessages.passwordCharacterLength');
        }
    }, [translate]);

    const validatePasswordMatch = React.useCallback((value: string) => {
        if (password !== value) {
            return translate('modules.createNewApp.steps.basicSettings.validationMessages.passwordMismatch');
        }
        return undefined;
    }, [password, translate]);

    return {
        validatePasswordPattern,
        validatePasswordMatch
    };
}
